import React from 'react';
import './Story.css';
import SwitchLight from '../../assets/images/light/switch-light.png';
import SwitchDark from '../../assets/images/dark/switch-dark.png';
import facehLight from '../../assets/images/light/light-menu.png';
import facehDark from '../../assets/images/dark/dark-menu.png';
import nav from '../../assets/images/nav.png';
import closeButton from '../../assets/images/menu-close.png';
import { useState } from 'react';
import { useEffect } from 'react';
import Navbar from '../navbar/Navbar';

import desktopLight from '../../assets/images/story/story-l.png';
import desktopDark from '../../assets/images/story/story-d.png';
import mobileLight from '../../assets/images/mobile/story/story-l.png';
import mobiledark from '../../assets/images/mobile/story/story-d.png';

const Story = (props) => {
  const [expand, setExpand] = useState(false);

  const [image, setImage] = useState(
    window.innerWidth > 425
      ? props.mod
        ? desktopDark
        : desktopLight
      : props.mod
      ? mobiledark
      : mobileLight
  );

  const setAnimation = (ev) => {
    let el = document.getElementById('foo');
    el.style.height = el.getBoundingClientRect().height + 5 + 'px';
  };

  const checkDrag = (e) => {
    let ds = document.getElementById('foo');

    window.innerWidth > 425
      ? props.mod
        ? (ds.style.top = '-30px')
        : (ds.style.top = '0px')
      : props.mod
      ? (ds.style.top = '-30px')
      : (ds.style.top = '0px');

    if (e >= 380) {
      if (window.innerWidth > 425 && props.mod) {
        setImage(desktopLight);
        props.changeTheme(!props.mod);
      } else if (window.innerWidth > 425 && !props.mod) {
        setImage(desktopDark);
        props.changeTheme(!props.mod);
      } else if (window.innerWidth <= 425 && props.mod) {
        setImage(mobiledark);
        props.changeTheme(!props.mod);
      } else if (window.innerWidth <= 425 && !props.mod) {
        setImage(mobileLight);
        props.changeTheme(!props.mod);
      }
    } else {
      if (window.innerWidth > 425 && props.mod) {
        setImage(desktopLight);
        props.changeTheme(!props.mod);
      } else if (window.innerWidth > 425 && !props.mod) {
        setImage(desktopDark);
        props.changeTheme(!props.mod);
      } else if (window.innerWidth <= 425 && props.mod) {
        setImage(mobiledark);
        props.changeTheme(!props.mod);
      } else if (window.innerWidth <= 425 && !props.mod) {
        setImage(mobileLight);
        props.changeTheme(!props.mod);
      }
    }
  };

  const navAction = () => {
    setExpand(!expand);
  };

  useEffect(() => {
    function chechSize(e) {
      if (window.innerWidth > 425 && props.mod) {
        setImage(desktopDark);
      } else if (window.innerWidth > 425 && !props.mod) {
        setImage(desktopLight);
      } else if (window.innerWidth <= 425 && props.mod) {
        setImage(mobiledark);
      } else if (window.innerWidth <= 425 && !props.mod) {
        setImage(mobileLight);
      }
    }
    window.addEventListener('resize', chechSize());
  });

  return (
    <div className="w-full h-screen relative flex flex-col overflow-y-scroll overflow-x-hidden">
      <div className="w-full h-full absolute">
        <img
          src={image}
          className="z-40 w-full h-full"
          loading="lazy"
        />
      </div>
      <div className="flex flex-col w-full h-full relative">
        <div className={`w-full h-auto flex flex-row justify-between relative`}>
          <div
            id="foo"
            className={`flex flex-col w-[178px] z-50  ss ${
              props.mod
                ? ' xxs:-top-[30px] sm:top-[0px]'
                : 'xxs:-top-[30px] sm:top-[0px]'
            }   xxs:h-[190px]  sm:h-auto xs:-left-10 sm:left-0  relative cursor-move`}
            onClick={(e) => {
              checkDrag(e.clientY);
            }}
          >
            <img
              src={props.mod ? SwitchDark : SwitchLight}
              alt="switch"
              className="w-auto h-full"
            />
          </div>
          <div className="flex flex-col w-fit h-fit cursor-pointer relative">
            <img
              src={props.mod ? facehLight : facehDark}
              className={`relative ${
                expand ? 'event-rm' : 'event-add'
              } navhover xxs:w-[60%] xxs:h-auto sm:w-[65%] xxs:left-12 xs:-top-2 sm:top-7 md:left-9 lg:left-0 sm:h-auto z-[999]`}
              alt="face"
              onClick={navAction}
            />
          </div>
        </div>

        <div
          className={`w-full   flex-col h-full  z-[999]  top-0 right-0   absolute   backdrop-blur-sm    ${
            expand ? 'flex' : 'hidden'
          } justify-center items-center`}
        >
          <div className=" flex-row flex  w-full h-fit justify-center items-center  relative z-0 bg-menu mb-20">
            <div className=" flex-row flex  xxs:w-[450px] sm:w-[530px] h-fit justify-center items-center  relative z-0">
              <img
                src={nav}
                alt="nav"
                className="  w-[1050px]  xxs:h-[400px] sm:h-[500px]     absolute    order-2 "
              />
              <img
                src={closeButton}
                alt="closeBtn"
                className="w-[130px] z-40 xxs:-top-10  xs:-top-10  sm:top-1 xxs:right-10 sm:right-16 xxs:h-[180px] sm:h-fit    absolute order-1      cursor-pointer close-btn"
                onClick={navAction}
              />
              <div className=" xxs:mt-12 sm:mt-16  relative sm:-left-5">
                <Navbar />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Story;
